import { format } from 'date-fns';

/** Filename-safe stamp (legacy cache-bust pattern: MMddyyyy + time). */
export function filenameDateStamp(date: Date = new Date()): string {
  return format(date, 'MMddyyyy_hhmmss');
}
